import React from 'react';
import { Navigate, Route, Routes, useNavigate, useParams } from 'react-router-dom';
import { access, defaultRoute } from '../../../common/Tool';
import { useAuth, useMetaContext, useTranslateContext, useUserConfigContext, useUserContext } from 'fennec-ui';
import { useDispatch, useSelector } from 'react-redux';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import Events from './Events';
import Federalgovernment from './Federalgovernment';
import Comission from './Comission';
import Reports from './Reports';
import Management from './Management';
import Settings from './Settings';
import { ConfigProvider, theme } from 'antd';
import { BreadcrumbsProvider, MenuLevelOneContext, MenuLevelOneElementContext, MenuLevelTwoContext, MenuLevelTwoElementContext } from '../../../common/Context';
import Finance from './Finance';
import Posts from './Posts';
var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

export default function Federationadministrator(props) {
    let { id } = useParams();
    const dispatch = useDispatch();
    let navigate = useNavigate();
    const auth = useAuth();
    const t = useTranslateContext();
    const user = useUserContext();
    const meta = useMetaContext();
    const [userConfig, setUserConfig] = useUserConfigContext();
    // const langSwitch = useLangSwitchContext();

    const siteAccess = useSelector(state => state.siteAccess.value);

    const role_by_id = useSelector(state => state.home.role_by_id);
    const status = useSelector(state => state.home.status, () => { }); // Статусы
    const notify = useSelector(state => state.home.notify, () => { }); // Уведомления

    const menu = (status, notify) => {
        const x = [
            {
                uuid: "finance",
                name: "Финансы",
                component: (props) => (<Finance {...props} />),
                role: [
                    { "ID": 5, "nazvanie": "ПрезидентФедерации" },
                ],
            },
            {
                uuid: "reports",
                name: "Отчеты",
                component: (props) => (<Reports {...props} />),
                role: [
                    { "ID": 5, "nazvanie": "ПрезидентФедерации" },
                    { "ID": 9, "nazvanie": "АдминистраторФедерации" },
                ],
            },
            {
                uuid: "management",
                default: true,
                name: "Управление",
                component: (props) => (<Management {...props} />),
                role: [
                    { "ID": 5, "nazvanie": "ПрезидентФедерации" },
                    { "ID": 9, "nazvanie": "АдминистраторФедерации" },
                ],
            },
            {
                uuid: "posts",
                name: "Посты",
                component: (props) => (<Posts {...props} />),
                role: [
                    { "ID": 5, "nazvanie": "ПрезидентФедерации" },
                    { "ID": 9, "nazvanie": "АдминистраторФедерации" },
                    { "ID": 38, "nazvanie": "СоздательПостов" },
                ],
            },
            // {
            //     uuid: "conference",
            //     name: "Конференция",
            //     component: (props) => (<div {...props} />),
            //     role: [
            //         { "ID": 8, "nazvanie": "АдминистраторКонференции" },
            //     ],
            // },
            {
                uuid: "federal-government",
                name: "Фед. правление",
                component: (props) => (<Federalgovernment {...props} />),
                role: [
                    { "ID": 5, "nazvanie": "ПрезидентФедерации" },
                    { "ID": 9, "nazvanie": "АдминистраторФедерации" },
                ],
            },
            {
                uuid: "events",
                name: "Мероприятия",
                component: (props) => (<Events {...props} />),
                role: [
                    { "ID": 5, "nazvanie": "ПрезидентФедерации" },
                    { "ID": 9, "nazvanie": "АдминистраторФедерации" },
                ],
            },
            {
                uuid: "comission",
                name: "Комиссии",
                component: (props) => (<Comission {...props} />),
                role: [
                    { "ID": 5, "nazvanie": "ПрезидентФедерации" },
                    { "ID": 9, "nazvanie": "АдминистраторФедерации" },
                ],
            },
            {
                uuid: "settings",
                name: "Настройки",
                component: (props) => (<Settings {...props} />),
                role: [
                    { "ID": 5, "nazvanie": "ПрезидентФедерации" },
                    { "ID": 9, "nazvanie": "АдминистраторФедерации" },
                ],
            },
        ]
        return x
    };

    return (
        <div>
            <MenuLevelTwoContext.Provider value={menu(status, notify)}>
                {(!siteAccess || siteAccess == "allow") && <Routes>
                    {defaultRoute(menu(status, notify), role_by_id)}
                    {menu(status, notify).map((e, idx) => {
                        if (e.component && access(e, role_by_id)) {
                            return <Route key={e.uuid} path={(e.uuid !== "*")?e.uuid + "/*":"*"} element={
                                <BreadcrumbsProvider value={{
                                    // parent: props?.level,
                                    uuid: e?.uuid,
                                    name: e?.name,
                                    color: e?.color,
                                    role: e?.role,
                                    hidden: e.hidden
                                }}>
                                    {e.component({})}
                                </BreadcrumbsProvider>}
                            />
                        }
                    })}
                </Routes>}
            </MenuLevelTwoContext.Provider>
        </div>
    );
}
